export enum Roles {
  USER = 1,
  ADMIN = 2,
  SUPERADMIN = 3,
}
